import React from 'react';
import { AppIcon, AppIconName } from '../../icons/appIcons.tsx';

interface EmptyStateProps {
  icon: AppIconName;
  title: string;
  description?: string;
  className?: string;
}

export default function EmptyState({ icon, title, description, className = '' }: EmptyStateProps) {
  return (
    <div className={`text-center py-8 ${className}`}>
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-100 text-gray-400">
        <AppIcon name={icon} className="w-8 h-8" strokeWidth={1.5} />
      </div>
      <p className="text-gray-600 font-medium">{title}</p>
      {description && <p className="text-sm text-gray-400 mt-2 max-w-sm mx-auto">{description}</p>}
    </div>
  );
}
